export const CALENDLY_URL =
  'https://leads.scalova.ai/';

export const SITE = {
  name: 'Scalova',
  tagline: 'Your second workforce',
  description:
    'Scalova gives every employee a persistent AI twin that learns how they work — and keeps producing deliverables overnight while they sleep, focus, or take Friday off.',
  calendly: CALENDLY_URL,
} as const;
